// extracted by mini-css-extract-plugin
export var navbarSubLink = "y_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "y_tk d_f0 d_dB";
export var subPageLink = "y_gf d_gf";
export var burger = "y_tL";
export var sublinkSize = "y_tM";
export var linkSize = "y_tN";
export var Link = "y_rm q_rm q_qD q_qY";